import { Role } from "@state/auth";

export type Permission = "create" | "read" | "update" | "delete";
export type Resource = "manage_ott";

/**
 * Check if user has a specific permission for a resource
 */
export const hasPermission = (
  roles: Role[],
  resource: Resource,
  permission: Permission
): boolean => {
  if (!roles || roles.length === 0) {
    return false;
  }

  return roles.some((role) => {
    const roleSchema = role.roleSchema;
    if (roleSchema && roleSchema[resource]) {
      return roleSchema[resource][permission] === true;
    }
    return false;
  });
};

/**
 * Check if user has any of the specified permissions for a resource
 */
export const hasAnyPermission = (
  roles: Role[],
  resource: Resource,
  permissions: Permission[]
): boolean => {
  return permissions.some((permission) => hasPermission(roles, resource, permission));
};

/**
 * Check if user has all of the specified permissions for a resource
 */
export const hasAllPermissions = (
  roles: Role[],
  resource: Resource,
  permissions: Permission[]
): boolean => {
  return permissions.every((permission) => hasPermission(roles, resource, permission));
};
